module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_SO.a6da89cb.txt";